module.exports = __webpack_public_path__ + "img/e29c841.png";